import { useAppSelector } from "@/store/hooks";

import type { EffectiveRole } from "../auth/types";
import { selectRoles } from "../store/userSlice";

export type RoleContextType = {
  roles: EffectiveRole[];
  setRole: (_r: EffectiveRole) => void;
  setRoles: (_r: EffectiveRole[]) => void;
};

export const useRole = (): RoleContextType => {
  const roles = useAppSelector(selectRoles);

  const setRole = () => {};
  const setRoles = () => {};

  return { roles, setRole, setRoles };
};
